// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/css/bootstrap_xlgrid.css
// module id = 1304
// module chunks = 0